import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import './Login.css';

const Login = ({ onLoginSuccess }) => {
  const [showError, setShowError] = useState(false);
  const { login, loading, error } = useAuth();

  const handleGoogleLogin = async () => {
    setShowError(false);
    const result = await login();
    
    if (!result.success) {
      setShowError(true);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>Gerenciador Aerotubos</h1>
          <p>Sistema de Gerenciamento de Produtos</p>
        </div>
        
        <div className="login-form">
          {(showError || error) && (
            <div className="error-message">
              {error || 'Falha no login. Tente novamente.'}
            </div>
          )}
          
          <button 
            onClick={handleGoogleLogin}
            className="google-login-button"
            disabled={loading}
          >
            {loading ? 'Entrando...' : 'Entrar com Google'}
          </button>
        </div>
        
        <div className="login-footer">
          <p>Entre com sua conta Google para acessar o sistema</p>
        </div>
      </div>
    </div>
  );
};

export default Login;
